export const YOTI_THEME = 'yoti'
export const POST_OFFICE_THEME = 'post-office'
export const NEUTRAL_THEME = 'neutral'
